<template>
  <div>
    <div class="container">
      <Breadcrumbs />
      <!-- Botón crear índice temático -->
      <div class="row">
        <div class ="col-12 dBtn">
          <q-btn
            data-cy="bNewIndiceTematico"
            @click="goToNewIndiceTematico()"
            unelevated
            class="bPrincipal"
          >
            CREAR ÍNDICE TEMÁTICO
          </q-btn>
        </div>
      </div>
      <!-- Tabla listado  -->
      <div class="row col-12">
        <div class="col-12">
          <ListadoIndicesTematicos
            :isLoading="isLoading"
            :visibleColumns="['name', 'order', 'editar','eliminar']"
            :selectionFormat="'none'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListadoIndicesTematicos from '@/components/IndicesTematicos/components/ListadoIndices.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import * as types from '@/storeModules/NGUD/types';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  components: {
    ListadoIndicesTematicos,
    Breadcrumbs
  },
  mixins: [Message, Validation, Loading],
  data: function () {
    return {
      isLoading: true
    };
  },
  created () {
    this.$store.dispatch(types.ACTION_GET_ALL_INDICES_TEMATICOS)
      .then(response => {
        this.hideLoading();
        this.isLoading = false;
      })
      .catch(() => { this.hideLoading(); this.isLoading = false; });
  },
  methods: {
    goToNewIndiceTematico () {
      this.$store.commit(types.MUTATE_INDICE_TEMATICO, null);
      this.$router.push({ name: 'form_new_indice_tematico' });
    }
  }
};
</script>

<style lang="scss" scoped>
  .bPrincipal {
    float: right;
  }
  .dBtn {
    margin-bottom: 15px;
  }

</style>
